import { render, staticRenderFns } from "./monchart.vue?vue&type=template&id=1a6f82d2&scoped=true&"
import script from "./monchart.vue?vue&type=script&lang=js&"
export * from "./monchart.vue?vue&type=script&lang=js&"
import style0 from "./monchart.vue?vue&type=style&index=0&id=1a6f82d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f82d2",
  null
  
)

export default component.exports